import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';
import { useLocale } from '../../hooks/useLocale';
import { useOnboarding } from './OnboardingProvider';
import { EditLanguagesForm } from '../cv/forms/EditLanguagesForm';
import { CvEnrichmentNotice, OnboardingSkipButton } from './web-step-chrome';

export function StepLanguages() {
  const { t } = useTranslation('auth');
  const { isRTL } = useLocale();
  const { nextStep, prevStep, skipStep } = useOnboarding();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        <div style={{ maxWidth: 560, marginInline: 'auto', width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
            <button onClick={prevStep} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
              <ChevronLeft size={24} color="var(--text-primary)" style={isRTL ? { transform: 'scaleX(-1)' } : undefined} />
            </button>
            <OnboardingSkipButton onSkip={skipStep} />
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 600, letterSpacing: '-0.01em', marginBottom: 4 }}>
            <span style={{ color: 'var(--text-secondary)' }}>{t('onboarding.languages.titleBase', { defaultValue: 'Add your' })} </span>
            <span style={{ color: '#5a2aff' }}>{t('onboarding.languages.titleAccent', { defaultValue: 'languages' })}</span>
          </h1>
          <p style={{ fontSize: 15, color: 'var(--text-secondary)', marginBottom: 16 }}>
            {t('onboarding.languages.subtitle', { defaultValue: 'List the languages you speak.' })}
          </p>
          <CvEnrichmentNotice />
          <EditLanguagesForm onSave={nextStep} closeOnSave={false} ctaLabel={t('onboarding.next', { defaultValue: 'Next' })} />
        </div>
      </div>
    </div>
  );
}
